import React from 'react'
import "./Trainer.css"
import { FaYoutubeSquare, FaInstagramSquare, FaFacebookSquare } from 'react-icons/fa'
import angad from "./images/trainer/angad.png"
import amindar from "./images/trainer/amindar.png"
import aryan from "./images/trainer/aryan.png"


const Card = ({ img, name, role, insta, youtube, fb }) => {
    return (
        <div className="trainer-card">
            <img src={img} alt="" />
            <div className="trainer-card-bottom">
                <p className="trainer-name">{name}</p>
                <p className="trainer-role">{role}</p>
                <div className="trainer-links">
                    <a href={insta} target='_blank' rel="noopener noreferrer">
                        <FaInstagramSquare />
                    </a>
                    <a href={youtube} target='_blank' rel="noopener noreferrer">
                        <FaYoutubeSquare />
                    </a>
                    <a href={fb} target='_blank' rel="noopener noreferrer">
                        <FaFacebookSquare />
                    </a>
                </div>
            </div>
        </div>
    )
}

const Trainer = () => {
    const OurTrainers = [
        {
            "id": 1,
            "photo": angad,
            "name": "Angad Bisht",
            "role": "Main Trainer",
            "social": [
                "https://www.instagram.com/angad_bisht/",
                "https://www.youtube.com/@AngadBishtMMA",
                "https://www.facebook.com/mutantmmacademy/"
            ],
        },
        {
            "id": 2,
            "photo": amindar,
            "name": "Aminder Bisht",
            "role": "Pro Trainer",
            "social": [
                "https://www.instagram.com/aminder_bisht57.2/",
                "https://www.youtube.com/@teamaminder7176",
                "https://www.facebook.com/mutantmmacademy/"

            ],
        },
        {
            "id": 3,
            "photo": aryan,
            "name": "Aryan Chauhan",
            "role": "Pro Trainer",
            "social": [
                "https://www.instagram.com/aryan_chauhanx2/",
                "https://www.youtube.com/@Mutantmmaacadmey_",
                "https://www.facebook.com/mutantmmacademy/",

            ],
        }
    ];

    return (
        <div className="main-trainer">
            <div className="trainer">
                <div className="trainer-1">
                    <p>Team</p>
                </div>
                <div className="trainer-heading">
                    <p>Our Trainers</p>
                </div>
                <div className="trainer-cards">
                    {OurTrainers.map((item) => (
                        <Card
                            key={item.id}
                            img={item.photo}
                            name={item.name}
                            role={item.role}
                            insta={item.social[0]}
                            youtube={item.social[1]}
                            fb={item.social[2]}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Trainer
